"use client";
import "./arrow-link.css";
const ArrowLink = ({ label, href = "#", target, icon, className = "" }) => {
  return (
    <a
      className={`r2-arrow-link ${className}`}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      href={href}
    >
      {label}
      {icon}
    </a>
  );
};

export default ArrowLink;
